import * as Actions from 'app/store/actions/mapping/mapping.actions';

const initialState = {
	entitiesUser: null,
	entitiesProject: null,
	searchMember: '',
	routeParams: {},
	contactDialog: {
		type: 'new',
		props: {
			open: false
		},
		data: null
	},
	switchHeader: null,
	teamName: null,
	handleProjects:[],
	handleUsersDetails:[],
	searchProjects: '',
	searchTeams: '',
	searchFilterCheckbox:[],
	handlingFilteredData:[],
};

const mappingReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_TEAM_PROJECTS: {
			return {
				...state,
				entitiesProject: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.GET_TEAM_USERS: {
			return {
				...state,
				entitiesUser: action.payload,
				routeParams: action.routeParams
			};
		}
		case Actions.MEMBER_SEARCH_TEXT: {
			return {
				...state,
				searchMember: action.searchMember,
			};
		}
		case Actions.OPEN_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: true
					},
					data: null
				}
			};
		}
		case Actions.CLOSE_NEW_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'new',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.OPEN_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: true
					},
					data: action.data
				}
			};
		}
		case Actions.CLOSE_EDIT_CONTACT_DIALOG: {
			return {
				...state,
				contactDialog: {
					type: 'edit',
					props: {
						open: false
					},
					data: null
				}
			};
		}
		case Actions.SWITCH_HEADER:{
			//console.log(' Getting Reducer console', action)
			return{
				...state,
				switchHeader: action.header,
			}
		}
		case Actions.TEAM_NAME:{
			//console.log(' Getting Reducer TeamName console', action)
			return{
				...state,
				teamName: action.team,
			}
		}
		case Actions.HANDLE_PROJECTS:{
			return{
				...state,
				handleProjects: action.payload,
			}
		}
		case Actions.HANDLE_USERS_DETAILS:{
			return{
				...state,
				handleUsersDetails: action.payload,
			}
		}
		case Actions.MAPPING_SEARCH_PROJECTS:{
			return{
				...state,
				searchProjects: action.payload,
			}
		}
		case Actions.MAPPING_SEARCH_TEAMS:{
			return{
				...state,
				searchTeams: action.payload,
			}
		}
		case Actions.SET_FILTER_CHECKBOX: {
			return {
				...state,
				searchFilterCheckbox: action.payload,
			};
		}
		case Actions.HANDLING_FILTERED_DATA: {
			return {
				...state,
				handlingFilteredData: action.payload,
			};
		}
		
		default: {
			return state;
		}
	}
};


export default mappingReducer;
